/* eslint-disable react/prop-types */
import React from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';

import InputBase from '@mui/material/InputBase';

import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import DeleteIcon from '@mui/icons-material/Delete';




import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Numeral from "numeral";
import {Link } from 'react-router-dom';
import DefaultContext  from "flexbiz-core/components/auth/Context";
import withMediaQuery  from "flexbiz-core/components/withMediaQuery";
import withApi  from "flexbiz-core/components/withApi";
import withAuth  from "flexbiz-core/components/withAuth";
import {gradientBackgroundStyle} from "flexbiz-core/utils"
import TextField from 'flexbiz-core/components/TextField';

import Hidden from 'flexbiz-core/components/Hidden';

import CartContext  from './CartContext';
import withCart  from './withCart';

const styles = {
  paper: {
    height:"100%"
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: 1,
  },
  submit: {
    margin: '3 0 2 0',
  },
}
class Cart extends React.Component{
  constructor(props){
    super(props);
    this.state={
      load:0,error:""
    }
    this.checkout = this.checkout.bind(this);
  }
  async componentDidMount(){
  }
  shouldComponentUpdate(nextProps,nextStates){
    return nextStates.load!=this.state.load
  }
  async checkout(){
    try{
      this.context.setProgressStatus(true);
      await this.props.createOrder();
      this.setState({load:this.state.load+1});
    }catch(e){
      this.context.alert(e.error || e.message || e);
    }
  }
  render(){
    const apis = this.props.apis;
    const {mainColor} = this.context.config;
    let maincolor = (this.context.config.secondaryColor);
    let bg = gradientBackgroundStyle(maincolor,{brightenFirst:this.context.config.fragBrightenFirst ||50,brightenSecond:this.context.config.fragBrightenSecond});
    return (
      <div style={{...styles.paper,...bg}}>
        <CartContext.Consumer>
            {({cart}) => {
              if(cart.length===0){
                return (
                  <Typography gutterBottom variant="subtitle2" style={{padding:20}}>{apis.getLabel("Không có sản phẩm nào trong giỏ của bạn")}</Typography>
                )
              }
              const t_tien_nt = cart.map(r=>r.tien_nt).reduce((a,b)=>a+b,0);
              const t_tien_hang_nt = cart.map(r=>r.tien_hang_nt).reduce((a,b)=>a+b,0)
              //console.log(cart);
              return (
                <>
                  <Hidden smDown implementation="js">
                    <div style={{height:"100%",overflow:"auto",display:"flex",flexDirection:"column"}}>
                        <div style={{flex:1,overflow:"auto"}}>
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell>{apis.getLabel("Sản phẩm")}</TableCell>
                                <TableCell>{apis.getLabel("Đơn vị tính")}</TableCell>
                                <TableCell align="right">{apis.getLabel("Giá")} (đ)</TableCell>
                                <TableCell align="right">{apis.getLabel("Số lượng")}</TableCell>
                                {/*<TableCell align="right">{apis.getLabel("Tiền hàng")}</TableCell>
                                <TableCell align="right">{apis.getLabel("Chiết khấu")}</TableCell>
                                <TableCell align="right">{apis.getLabel("Phải trả")}</TableCell>*/}
                                <TableCell align="right">{apis.getLabel("Thành tiền")}</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {cart.map(row => (
                                <TableRow key={row._id}>
                                  <TableCell component="th" scope="row">
                                    <div style={{marginBottom:10}}>
                                      <Link style={{textDecoration:'none',color:mainColor}} to={`/product/${row.dmvt}-${encodeURI((row.ten_vt||"").split(" ").join("-").split("/").join("-"))}`}  title={row.ten_vt}>
                                        <Typography gutterBottom variant="body2">{row.ten_vt} ({row.ma_vt})</Typography>
                                        {row.thuoc_tinh && row.thuoc_tinh.details && row.thuoc_tinh.details.length>0  &&
                                        <Typography component="div" variant="caption">
                                          {row.thuoc_tinh.details.map(d=>{
                                            return `${d.ten_bien_the}: ${d.gia_tri_bien_the}`
                                          }).join(", ")}
                                        </Typography>}
                                      </Link>
                                    </div>
                                    <div style={{display:"flex"}}>
                                      <IconButton variant="outlined" size="small" color="default" aria-label="Remove" onClick={()=>this.props.updateCart({...row,sl_xuat:row.sl_xuat-1})}>
                                        <RemoveIcon />
                                      </IconButton>
                                      <InputBase
                                        value={row.sl_xuat}
                                        onChange={event=>this.props.updateCart({...row,sl_xuat:Number(event.target.value)})}
                                        type="number"
                                        style={{width:"60px"}}

                                        inputProps={{style:{ textAlign: 'center',width:'100%' }}}
                                        margin="dense"
                                        variant="outlined"
                                      />
                                      <IconButton variant="outlined" size="small" color="default" aria-label="Add"  onClick={()=>this.props.updateCart({...row,sl_xuat:row.sl_xuat+1})}>
                                        <AddIcon />
                                      </IconButton>
                                      <IconButton variant="outlined"  size="small" color="default" style={{marginLeft:10}} onClick={()=>this.props.deleteCart(row)}><DeleteIcon/></IconButton>
                                    </div>
                                    <div style={{color:row.ton<row.sl_xuat?"red":"green",marginTop:10}}>
                                      <TextField
                                          value={row.ghi_chu}
                                          label={apis.getLabel("Ghi chú")}
                                          fullWidth
                                          onChange={event=>this.props.updateCart({...row,ghi_chu:event.target.value})}
                                          type="text"
                                          margin="dense"
                                          variant="outlined"
                                        />
                                    </div>
                                  </TableCell>
                                  <TableCell component="th" scope="row">
                                    {row.ma_dvt}
                                  </TableCell>
                                  {/*<TableCell align="right">{Numeral(row.gia_ban_nt).format()} {row.ma_nt||"đ"}</TableCell>
                                  <TableCell align="right">{row.sl_xuat}</TableCell>
                                  <TableCell align="right">{Numeral(row.tien_hang_nt).format()} {row.ma_nt||"đ"}</TableCell>
                                  <TableCell align="right"  style={{color:"red"}}>{Numeral(row.tien_ck_nt).format()} {row.ma_nt||"đ"} {row.ty_le_ck?`(${row.ty_le_ck}%)`:''}</TableCell>
                                  <TableCell align="right">{Numeral(row.tien_nt).format()}</TableCell>*/}

                                  <TableCell align="right">
                                    {Numeral(row.gia_ban_le_sau_ck).format()} {row.ma_nt||"đ"} 
                                    {row.gia_ban_ck? <span style={{color:'red'}}>(-{Numeral(row.gia_ban_ck).format()})</span>:null}
                                  </TableCell>
                                  <TableCell align="right">{row.sl_xuat}</TableCell>
                                  <TableCell align="right">{Numeral(row.tien_nt).format()}</TableCell>


                                </TableRow>
                              ))}
                              <TableRow>
                                <TableCell component="th" scope="row">
                                  <div>
                                    <Typography gutterBottom variant="subtitle2">{apis.getLabel("Tổng cộng")}</Typography>
                                  </div>
                                </TableCell>
                                <TableCell component="th" scope="row">

                                </TableCell>
                                <TableCell align="right"></TableCell>
                                <TableCell align="right"><Typography gutterBottom variant="subtitle2">{Numeral(cart.map(r=>r.sl_xuat).reduce((a,b)=>a+b,0)).format()}</Typography></TableCell>
                                <TableCell align="right"><Typography gutterBottom variant="subtitle2">{Numeral(t_tien_hang_nt).format()}</Typography></TableCell>
                                <TableCell align="right"  style={{color:"green"}}><Typography gutterBottom variant="subtitle2">{Numeral(t_tien_nt).format()}</Typography></TableCell>
                                <TableCell align="right"><Typography gutterBottom variant="subtitle2">{Numeral(cart.map(r=>r.tien).reduce((a,b)=>a+b,0)).format()}</Typography></TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </div>
                        {this.state.error?
                          <div style={{marginTop:10,color:"red"}}>
                            {this.state.error}
                          </div>
                          :null
                        }
                        <div style={{margin:10}}>
                          <Button variant="contained" color="primary" size="large" fullWidth onClick={this.checkout}>
                            {apis.getLabel("Gửi yêu cầu")}
                          </Button>
                        </div>
                    </div>
                  </Hidden>
                  <Hidden smUp implementation="js">
                    <div style={{height:"100%",overflow:"auto",display:"flex",flexDirection:"column"}}>
                      <div style={{flex:1,overflow:"auto"}}>
                        {cart.map(row => (
                          <Paper key={row._id} style={{padding:10,margin:10}}>
                            <div style={{display:"flex",flexDirection:"row"}}>
                                <div style={{paddingRight:10}}>
                                  <img src={`${this.context.config.server_url}${row.picture_thumb}?access_token=${this.context.userInfo.token}`} style={{width:128,height:128,objectFit:"contain"}}/>
                                </div>
                                <div style={{flex:1}}>
                                  <div>
                                    <Typography gutterBottom variant="body2">{row.ten_vt} ({row.ma_vt})</Typography>
                                  </div>
                                  {row.thuoc_tinh && row.thuoc_tinh.details && row.thuoc_tinh.details.length>0  && 
                                  <Typography component="div" variant="caption">
                                    {row.thuoc_tinh.details.map(d=>{
                                      return `${d.ten_bien_the}: ${d.gia_tri_bien_the}`
                                    }).join(", ")}
                                  </Typography>}
                                  <div style={{display:"flex"}}>
                                    <IconButton size="small" color="default" aria-label="Remove" onClick={()=>this.props.updateCart({...row,sl_xuat:row.sl_xuat-1})}>
                                      <RemoveIcon />
                                    </IconButton>
                                    <InputBase
                                      value={row.sl_xuat}
                                      onChange={event=>this.props.updateCart({...row,sl_xuat:Number(event.target.value)})}
                                      type="number"
                                      style={{width:"60px"}}

                                      inputProps={{style:{ textAlign: 'center',width:'100%' }}}
                                      margin="dense"
                                      variant="outlined"
                                    />
                                    <IconButton size="small" color="default" aria-label="Add"  onClick={()=>this.props.updateCart({...row,sl_xuat:row.sl_xuat+1})}>
                                      <AddIcon />
                                    </IconButton>

                                    <IconButton size="small" color="default" onClick={()=>this.props.deleteCart(row)}  style={{marginLeft:10}}><DeleteIcon/></IconButton>
                                  </div>
                                  
                                  {/*<div  style={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center',marginTop:10}}>
                                    <Typography>
                                      {apis.getLabel("Giá")}
                                    </Typography>
                                    <Typography variant="subtitle1">
                                      {Numeral(row.gia_ban_nt).format("0,000.00")} {row.ma_nt||"đ"}
                                    </Typography>
                                  </div>

                                  <div  style={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center',marginTop:10}}>
                                    <Typography>
                                      {apis.getLabel("Tiền hàng")}
                                    </Typography>
                                    <Typography variant="subtitle1">
                                      {Numeral(row.tien_hang_nt).format("0,000.00")} {row.ma_nt||"đ"}
                                    </Typography>
                                  </div>
                                  {row.tien_ck_nt?
                                    <>
                                      <div  style={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center',marginTop:10}}>
                                        <Typography>
                                          {apis.getLabel("Chiết khấu")}
                                        </Typography>
                                        <Typography variant="subtitle1" style={{color:"red"}}>
                                          {Numeral(row.tien_ck_nt).format("0,000.00")} {row.ma_nt||"đ"} {row.ty_le_ck?`(${row.ty_le_ck}%)`:''}
                                        </Typography>
                                      </div>

                                      <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center',marginTop:10}}>
                                        <Typography>
                                          {apis.getLabel("Phải trả")}
                                        </Typography>
                                        <Typography variant="subtitle1">
                                          {Numeral(row.tien_nt).format("0,000.00")} {row.ma_nt||"đ"}
                                        </Typography>
                                      </div>
                                    </>
                                    :null
                                  }*/}
                                  <div  style={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center',marginTop:10}}>
                                    <Typography>
                                      {apis.getLabel("Giá")}
                                    </Typography>
                                    <Typography variant="subtitle1">
                                      {Numeral(row.gia_ban_le_sau_ck).format("0,000.00")} {row.ma_nt||"đ"} / {row.ma_dvt}
                                      {row.gia_ban_ck? <span style={{color:'red'}}>(-{Numeral(row.gia_ban_ck).format()})</span>:null}
                                    </Typography>
                                  </div>

                                  <div  style={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center',marginTop:10}}>
                                    <Typography>
                                      {apis.getLabel("Thành tiền")}
                                    </Typography>
                                    <Typography variant="subtitle1">
                                      {Numeral(row.tien_nt).format("0,000.00")} {row.ma_nt||"đ"}
                                    </Typography>
                                  </div>
                                </div>
                            </div>
                            <div style={{color:row.ton<row.sl_xuat?"red":"green",marginTop:10}}>
                                <TextField
                                  label={apis.getLabel("Ghi chú")}
                                  value={row.ghi_chu}
                                  fullWidth
                                  onChange={event=>this.props.updateCart({...row,ghi_chu:event.target.value})}
                                  type="text"
                                  margin="dense"
                                  variant="outlined"
                                />
                            </div>
                          </Paper>
                        ))}

                        {this.state.error?
                          <div style={{marginTop:10,color:"red",textAlign:'center'}}>
                            {this.state.error}
                          </div>
                          :null
                        }
                      </div>
                      <div style={{textAlign:'center'}}>
                        <Typography variant="h6" component="div" style={{padding:10}}>
                          {`${apis.getLabel("Tổng cộng: ")} ${Numeral(t_tien_nt).format()} `} {(this.context.appInfo.par||{}).ma_nt||"đ"}
                        </Typography>
                        <div style={{padding:20}}>
                          <Button variant="contained" color="primary" size="large" fullWidth onClick={this.checkout}>
                            {apis.getLabel("Tạo đơn hàng")}
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Hidden>
                </>
              );}}
        </CartContext.Consumer>
      </div>
    );
  }
}
Cart.contextType = DefaultContext;
export default withMediaQuery('(max-width:480px)')(withApi(withAuth(withCart(Cart))));
